import React from "react";
import ElfsightWidget from "../../components/ElfsightWidget";

const CaseStudies = () => {
  return (
    <div className="page-cases" id="case-studies" style={{background: "white"}}>
      {/* Page Header */}
      <section className="page-cases__header">
        <div className="container">
          <h1 className="page-cases__title">Case Studies</h1>
          <p className="page-cases__subtitle">
            A selection of architectural and system design decisions made while scaling startup products.
          </p>
        </div>
      </section>

      {/* Elfsight Widget with Skeleton Loader */}
      <section className="page-cases__content">
        <div className="container">
          <ElfsightWidget columns={3} rows={1}>
            <div className="elfsight-app-6a59454d-f9b3-410b-9521-abcf9f1e2f6e" data-elfsight-app-lazy></div>
          </ElfsightWidget>
        </div>
      </section>
    </div>
  );
};

export default CaseStudies;
